import btn from './btn';

export default class productlist {
    constructor(){

        this.$target;
        this.$btn;
        this.$btn02;
        this.$img;

        this.btn = new btn();

        this.deviceSize;

    }
    init(){

        this.$target = document.querySelectorAll(".js__p-li");
        this.$btn = document.querySelectorAll(".js__p-li .c-btn");
        this.$btn02 = document.querySelectorAll(".js__p-li .c-btn02");
        this.$img = document.querySelectorAll(".js__p-li .image");

        // TweenMax.set(this.$btn,{
        //     y : 30,
        //     opacity : 0
        // })


        for(let i in this.$target){

            if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める

            this.$target[i].addEventListener("mouseenter",(e)=>{

                if(this.deviceSize == "sp") return;

                this.enter(e.target,i);

            });
            this.$target[i].addEventListener("mouseleave",(e)=>{

                if(this.deviceSize == "sp") return;

                this.leave(e.target,i);

            });

        }


    }
    enter($t,i){
        TweenMax.to(this.$btn[i], 0.6, {
            y: 0,
            opacity: 1
        });
        if (this.$btn02[i]) {
            TweenMax.to(this.$btn02[i], 0.6, {
                y: 0,
                opacity: 1,
                delay: 0.3
            });
        }
        TweenMax.to(this.$img[i],0.6,{
            opacity : this.deviceSize=="sp"?1:0.5
        })

        // this.btn.enter($t);
    }
    leave($t,i){
        TweenMax.to(this.$btn[i],0.6,{
            y : 30,
            opacity : 0,
            overwrite: true
        })
        if(this.$btn02[i]){
            TweenMax.to(this.$btn02[i],0.6,{
                y : 30,
                opacity : 0,
                overwrite: true
            })
        }
        TweenMax.to(this.$img[i],0.6,{
            opacity : 1
        })
        // this.btn.leave($t);

    }
    resize(deviceSize){

        if(deviceSize !== this.deviceSize){
            this.deviceSize = deviceSize;
            if(deviceSize=="sp"){

                for(let i in this.$target){

                    if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める

                    this.enter(this.$target[i],i);

                }
            }else{
                for(let i in this.$target){

                    if(this.$target[i].nodeType!=1) continue; // dom要素以外は処理止める

                    this.leave(this.$target[i],i);

                }

            }
        }


    }
}
